export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: '流畅阅读',
      description: '下拉式阅读体验，手机和电脑均可流畅浏览，随时随地享受韩漫乐趣。',
    },
    {
      icon: 'ri-cloud-line',
      title: '海量资源',
      description: '收录丰富韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑等多种类型。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日更新',
      description: '热门韩漫每日更新，精彩故事不停歇，追更从此不再等待。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '优质内容',
      description: '严格的内容筛选机制，确保每一部作品都是精心挑选的优质漫画。',
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            为什么选择香香漫画
          </h2>
          <p className="text-sm text-foreground-500">我们致力于为您提供最好的韩漫阅读体验</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-50 group-hover:bg-primary-100 transition-colors duration-300 mb-4">
                <i className={`${feature.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">{feature.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}